import { Helmet } from 'react-helmet-async';
import { useGoogleReviews } from '../hooks/useGoogleReviews';

const SEO = () => {
  const { rating, totalReviews } = useGoogleReviews();
  
  const schemaOrgLocal = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Gráfica Rápida Infortech - Assistência Técnica & Papelaria",
    "image": "https://customer-assets.emergentagent.com/job_impressao-tech-ce/artifacts/j2ddoafo_LOGO%20OFICIAL%20FINALIZADA_Prancheta%201_Prancheta%201.png",
    "@id": "",
    "url": typeof window !== 'undefined' ? window.location.origin : "",
    "telephone": "(85) 98519-5369",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Avenida Bezerra de Menezes, 1051B",
      "addressLocality": "Fortaleza",
      "addressRegion": "CE",
      "addressCountry": "BR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -3.7408,
      "longitude": -38.5665
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": rating.toFixed(1),
      "reviewCount": totalReviews.toString()
    },
    "priceRange": "$$",
    "description": "Gráfica rápida em Fortaleza oferecendo impressão, xerox, carimbos personalizados, papelaria completa e assistência técnica para computadores e notebooks. Atendimento rápido e preço justo."
  };

  return (
    <Helmet>
      <title>Gráfica Rápida Infortech Fortaleza | Impressão, Papelaria, Carimbos e Assistência Técnica</title>
      <meta name="description" content="Gráfica rápida em Fortaleza: impressão A3/A4, xerox, carimbos personalizados, papelaria completa e assistência técnica para computadores. Orçamento grátis pelo WhatsApp!" />
      <meta name="keywords" content="gráfica fortaleza, impressão fortaleza, xerox fortaleza, carimbos fortaleza, papelaria fortaleza, assistência técnica fortaleza, conserto notebook fortaleza, gráfica rápida, impressão A3, plastificação fortaleza, encadernação fortaleza" />
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgLocal)}
      </script>
    </Helmet>
  );
};

export default SEO;
